import React, {useState, useEffect} from "react";
import './professionalPage.scss';
import Loading from '../Loading/loading';
import { useHistory } from 'react-router-dom';
import {ReactComponent as PhoneCallIcon} from '../../assests/phone-call-icon.svg';
import {ReactComponent as WhatsappIcon} from '../../assests/whatsapp-icon.svg';
import {ReactComponent as WebsiteIcon} from '../../assests/website-icon.svg';
import {ReactComponent as InstagramIcon} from '../../assests/instagram-icon.svg';
import {ReactComponent as FacebookIcon} from '../../assests/facebook-icon.svg';
import {ReactComponent as WazeIcon} from '../../assests/waze-icon.svg';
import {ReactComponent as ShareIcon} from '../../assests/share-icon.svg';
import {ReactComponent as StarIcon} from '../../assests/star-icon.svg';
import {ReactComponent as StarFilledIcon} from '../../assests/star-filled-icon.svg';
import {sendWhatsAppMessage, shareApp, isMobile} from '../../utils';
import {addToFavorites, removeFromFavorites, isFavorite as isFavoriteFromLocalStorage} from '../../store/localStorageMgr'
import {createAnalyticsEvent} from '../../firebase/firebase';

import getIcon from '../../config/iconToCategoryMap';

export default function ProfessionalPage(props) {
    const {id, loading, professionals} = props;

    const [showPopUp, setShowPopUp] = useState(false);
    const [isFavorite, setIsFavorite] = useState(isFavoriteFromLocalStorage({id}));

    const history = useHistory();

    if(loading) return <Loading/>

    const professional = professionals.find(f=>f.id === id);

    if(!professional){
        history.push('/');
        return null;
    }

    const {businessName, ownerName, services, productLocation, address, phoneNumber, webLink, instagram, facebook, gps, activityTime, category, logoUrl} = professional;

    const isMobileMode = isMobile();

    const renderBusinessName = ()=>{
        if(!businessName) return null;
        return <div className={'business-name-container'}>
            {businessName}
            {logoUrl ? <img className={'user-logo-icon'} src={logoUrl} /> : getIcon(category)}
        </div>
    }

    const renderOwnerName = ()=>{
        if(!ownerName) return null;
        return <div className={'owner-name-container'}>
            <div>{ownerName}</div>
        </div>
    }


    const renderServices = ()=>{
        if(!services) return null;
        const lines = services.split('.');
        return <div className={'services-container'}>{
            lines.map(line=>{
                if(!line.trim()) return null;
                return <div>{line}{line.endsWith('.') ? '' : '.'}</div>
            })
        }</div>
    }

    const renderClickToCallButton = ()=>{
        let number;
        if(phoneNumber.startsWith('0')){
            number = phoneNumber.toString();
        }
        else{
            number = `0${phoneNumber}`
        }

        let phoneToView;
        if(number.length === 10){
            phoneToView = `${number.slice(0,3)}-${number.slice(3,number.length)}`;
        }else{
            phoneToView = `${number.slice(0,2)}-${number.slice(2,number.length)}`;
        }

        return <a href={`tel:${number}`} className={'phone-dialog-container'} onClick={()=>{
            createAnalyticsEvent({eventName: 'profession-page-phone-dialog-click', eventParams: {id, businessName, ownerName, category, number}});}
        }>
            <PhoneCallIcon className={'phone-call-icon'}/>
            <div className={'phone-dialog-button'}>{phoneToView}</div>
        </a>
    }

    const renderCategory = ()=>{
        if(!category) return null;
        return <div className={'product-category-container'}>
            <div className={'bold-key'}>קטגוריה:</div>
            <div>{category}</div>
        </div>
    }

    const renderProductLocation = ()=>{
        if(!productLocation) return null;
        return <div className={'product-location-container'}>
            <div className={'bold-key'}>מיקום:</div>
            <div>{productLocation}</div>
        </div>
    }

    const renderAddress = ()=>{
        if(!productLocation) return null;
        return <div className={'address-container'}>
            <div className={'bold-key'}>כתובת:</div>
            <div>{address}</div>
        </div>
    }

    const renderActivityTime = ()=>{
        if(!activityTime) return null;
        return <div className={'activity-time-container'}>
            <div className={'bold-key'}>שעות פעילות:</div>
            <div>{activityTime}</div>
        </div>
    }

    const renderButtonLinks = ()=>{
        const links = [];

        if(phoneNumber && phoneNumber.length === 9){
            links.push({
                icon: <WhatsappIcon className={'button-link-icon'}/>,
                text: 'whatsapp',
                onClick: ()=> {
                    createAnalyticsEvent({eventName: 'profession-page-send-whatsapp', eventParams: {id, businessName, ownerName, category, phoneNumber}});
                    isMobileMode ? sendWhatsAppMessage({msg: `היי ${ownerName} !`, phoneNumber: `+972${phoneNumber}`}) : window.open(`https://api.whatsapp.com/send?phone=+972${phoneNumber}`, '_blank').focus();
                }
            })
        }

        if(webLink){
            links.push({
                icon: <WebsiteIcon className={'website-icon'}/>,
                text: 'אתר אינטרנט',
                onClick: ()=>{
                    createAnalyticsEvent({eventName: 'profession-page-move-to-website', eventParams: {id, businessName, ownerName, category, webLink}});
                    window.open(webLink, '_blank').focus();
                }
            })
        }

        if(facebook){
            links.push({
                icon: <FacebookIcon className={'facebook-icon'}/>,
                text: 'facebook',
                onClick: ()=>{
                    createAnalyticsEvent({eventName: 'profession-page-move-to-facebook', eventParams: {id, businessName, ownerName, category, facebook}});
                    window.open(facebook, '_blank').focus();
                }
            })
        }

        if(instagram){
            links.push({
                icon: <InstagramIcon className={'instagram-icon'}/>,
                text: 'instagram',
                onClick: ()=> {
                    createAnalyticsEvent({eventName: 'profession-page-move-to-instagram', eventParams: {id, businessName, ownerName, category, instagram}});
                    window.open(instagram, '_blank').focus();
                }
            })
        }

        if(gps){
            const [latitude, longitude] = gps.split(',');
            if(latitude && longitude){
                links.push({
                    icon: <WazeIcon className={'waze-icon'}/>,
                    text: 'ניווט',
                    onClick: ()=>{
                        createAnalyticsEvent({eventName: 'profession-page-move-to-waze', eventParams: {id, businessName, ownerName, category, latitude, longitude}});
                        window.open(isMobileMode ? `geo:${latitude},${longitude}` : `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank').focus();
                    }
                })
            }
        }

        links.push({
            icon: <ShareIcon className={'share-icon'}/>,
            text: 'שתף',
            onClick: ()=> {
                createAnalyticsEvent({eventName: 'profession-page-share', eventParams: {id, businessName, ownerName, category}});
                if(isMobileMode){
                    shareApp(id);
                }else{
                    try {
                        navigator.clipboard.writeText(`${window.location.origin}/${id}`);
                        setShowPopUp(true);
                        setTimeout(()=>setShowPopUp(false), 2000)
                    }catch (e){
                        console.error(`failed to copy text: ${e}`);
                    }
                }
            }
        })

        links.push({
            icon: isFavorite ? <StarFilledIcon className={'favorite-icon'}/>: <StarIcon className={'favorite-icon'}/>,
            text: isFavorite ? 'הסר ממועדפים' : 'הוסף למועדפים',
            onClick: ()=> {
                createAnalyticsEvent({eventName: 'profession-page-favorite', eventParams: {id, businessName, ownerName, category, isFavorite}});
                setIsFavorite(!isFavorite);
                isFavorite ? removeFromFavorites({id}) : addToFavorites({id});
            }
        })

        return <React.Fragment>
            <div className={'button-links-container'}>
                {links.map(linkObj=><div className={'button-link-container'} onClick={linkObj.onClick}>
                    <div className={'button-links-circle'}>{linkObj.icon}</div>
                    <div className={'button-link-text'}>{linkObj.text}</div>
                </div>)}
            </div>
            {showPopUp ? <div className={'pop-up-container'}>לינק הועתק!</div> : null}
        </React.Fragment>
    }

    return (
       <div className={'professional-page-container'}>
           <div className={'professional-page-header'}>
               <a onClick={()=>history.push('/')} href={'#'}>המקצוענים של מערבא</a>
               {' > '}
               <a onClick={()=>history.push(`/home/welcome/${category}`)} href={'#'}>{category}</a>
               {' > '}
               {businessName}
           </div>
           <div className={'professional-page-top-level'}>
               {renderBusinessName()}
               {renderOwnerName()}
           </div>
           <div className={'professional-page-body'}>
               {renderServices()}
               {renderClickToCallButton()}
               {renderCategory()}
               {renderProductLocation()}
               {renderAddress()}
               {renderActivityTime()}
               {renderButtonLinks()}
               {/*<div className={'found-bug-container'}>*/}
               {/*    <div>מצאתם טעות?</div>*/}
               {/*    <button>לחצו כאן</button>*/}
               {/*</div>*/}
           </div>
           <div></div>

       </div>
    );
}